export default __webpack_public_path__ + "static/media/fish_thumb.61d36d32.jpg";